import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import axios from 'axios';
import { parseJwt } from '../components/utilities/utils';
import { BASE_URLS, PLATFORM_TYPE, USERTYPE } from '../constants/constants';
import { createEncryptedBaseQuery } from '../app/encryptedBaseQuery';

export const loginServiceApi = createApi({
    reducerPath: 'loginServiceApi',
    baseQuery: createEncryptedBaseQuery({ baseUrl: BASE_URLS.LOGIN_BASE_URL,
    prepareHeaders: (headers) => {
            headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
            return headers;
          },
    }),
    endpoints: (builder) => ({
      Passwordverification: builder.mutation({
        query: (data) => ({
          headers: {
            'Content-Type': 'application/json'
          },
          url: 'api/v1/authn-sso/password-flow',
          method: 'POST',
          credentials:"include",
          body: data,
          contentType : 'application/json'
        })
      }),

      Otpsent: builder.mutation({
        query: (data) => ({
          headers: {
            'Content-Type': 'application/json'
          },
          url: 'api/v1/authn-sso/otp-flow-send',
          method: 'POST',
          credentials:"include",
          body: data
        })
      }),

      ResendOtp: builder.mutation({
        query: (data) => ({
          headers: {
            'Content-Type': 'application/json'
          },
          url: '/api/v1/authn-sso/re-send-otp',
          method: 'POST',
          credentials:"include",
          body: data
        })
      }),


      Otpverify: builder.mutation({
        query: (data) =>({
        
          headers: {
            'Content-Type': 'application/json',
            
          },
          url: 'api/v1/authn-sso/otp-flow-verify',
          method: 'POST',
          credentials:"include",
          body: data
       }),

        // transformResponse: (response) => {
        //   localStorage.setItem("userrole",parseJwt(response.access_token).realm_access.roles[0])
        //   localStorage.setItem("roles",parseJwt(response.access_token).realm_access.roles)
        //   localStorage.setItem("access_token",response.access_token)
        //   // window.location.href = "/" +parseJwt(response.access_token).realm_access.roles[0]
        //   return response
        // }
      }),

      changePassword: builder.mutation({
        query: (data) =>({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.first_token,
            'currentRole': localStorage.first_role,
            "atkn_bnd": localStorage?.atkn_bnd,
            "rtkn_bnd": localStorage?.rtkn_bnd,
            "channelidobo": "ETPBMS",      
          },
          url: BASE_URLS.USERMANAGEMENT_BASE_URL + 'api/v1/etpbms-user-management/change/password',
          method: 'POST',
          credentials:"include",
          body: data
       })
      }),

      changeMigratedPassword: builder.mutation({
        query: (data) =>({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.first_token,
            'currentRole': localStorage.first_role
          },
          url: BASE_URLS.USERMANAGEMENT_BASE_URL + 'api/v1/user-management/change/user/password',
          method: 'POST',
          credentials:"include",
          body: data
       })
      }),
      refreshToken: builder.mutation({
        query: (data) =>({
          headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.first_token,
            // 'currentRole': localStorage.userrole
            "atkn_bnd": localStorage?.atkn_bnd,
            "rtkn_bnd": localStorage?.rtkn_bnd,
            "channelidobo": "ETPBMS",      
          },
          url: 'api/v1/authn-sso/refresh',
          method: 'POST',
          credentials:'include',
          body: data
       })
      }),
      logout: builder.mutation({
        query: (data) =>({
          headers: {
            'Content-Type': 'application/json',
            'applicationName':
            (localStorage.userrole=="cs"||localStorage.userrole=="ro")?USERTYPE.ETPBMS:
            (localStorage.userrole=="nodal"||localStorage.userrole=="record"||
            localStorage.userrole=="unit")?USERTYPE.SVP:USERTYPE.ERONET,            
            'Authorization': 'Bearer ' + localStorage?.access_token,
            // 'userName':parseJwt(localStorage?.access_token)?.preferred_username,            
            'refreshToken': localStorage?.refreshToken,      
            "atkn_bnd": localStorage?.atkn_bnd,
            "rtkn_bnd": localStorage?.rtkn_bnd,
            "channelidobo": "ETPBMS",      
            },
          url: 'api/v1/authn-sso/logout',
          method: 'POST',
          credentials:"include",
          body: data
        })
      }),
      verifyToken: builder.query({
        query: (data) =>({
          headers: { 
            'Content-Type': 'application/json',
            // 'applicationName':
            // (localStorage.userrole=="cs"||localStorage.userrole=="ro")?'etpbs':
            // (localStorage.userrole=="nodal"||localStorage.userrole=="record"||
            // localStorage.userrole=="unit")?'svp':'back_office',            
            // // 'userName':parseJwt(localStorage?.access_token)?.preferred_username,            
            // // 'refreshToken': localStorage?.refreshToken,      
            // "atkn_bnd": localStorage?.atkn_bnd,
            // "rtkn_bnd": localStorage?.rtkn_bnd,
            "channelidobo": "ETPBMS",      
            },
          url: 'api/v1/authn-sso/validate-token',
          method: 'GET',
          credentials:"include",
        })
      }),
    }),
  })
  
 export const { useGetloginrequestsMutation ,
  useChangeMigratedPasswordMutation, 
  useGetStatesGQuery, 
  useGetDistrictGQuery, 
  useGetTownQuery, 
  usePasswordverificationMutation, 
  useOtpsentMutation,
  useOtpverifyMutation,
  useChangePasswordMutation,
  useRefreshTokenMutation,
  useLogoutMutation,
useResendOtpMutation,
useLazyVerifyTokenQuery
} = loginServiceApi


 
